export const intervalMapping: { [key: string]: string } = {
    month: "Monthly",
    year: "Yearly",
};

export const getIntervalLabel = (interval: string): string =>
    intervalMapping[interval] || interval;

export const paymentSymbol: { [key: string]: string } = {
    USD: "$",
    INR: "₹",
};
